import { format } from 'date-fns';

import { getPeriodLabels } from '.';

export const getPeriodLabelsForQuarterDateRange = (
    quarter: DateRange,
): PeriodLabels => {
    const { start, end } = quarter;

    const start_date = format(start, 'yyyy-MM-dd');
    const end_date = format(end, 'yyyy-MM-dd');

    return getPeriodLabels({
        start_date,
        end_date,
        unit: 'quarter',
    });
};
